export const LEAD = `LEAD`;

export const GET_BANK_BRANCH_CODE = `${LEAD}/GET_BANK_BRANCH_CODE`;
export const SET_BANK_BRANCH_CODE = `${LEAD}/SET_BANK_BRANCH_CODE`;
export const SET_LEAD_SELECTED_ITEMS = `${LEAD}/SET_LEAD_SELECTED_ITEMS`;
